import { app }                               from '../app';
import IScope = angular.IScope;
import { ITranslationService }               from '../services/TranslationService';
import { UniqueIdService, IUniqueIdService } from '../services/UniqueIdService';
import IComponentController = angular.IComponentController;
import { lang }                              from 'moment';

export class LanguageChooserComponent implements IComponentController {

    private rootScope:IRootScope;
    private sce:ng.ISCEService;
    private translationService:ITranslationService;
    private uniqueIdService:IUniqueIdService;

    languages:ILanguage[];
    language:ILanguage;
    languageLocale:string;
    languagesDisplayed:{ [s:string]:string } = {};
    selectId:string;
    additionalClass:any;

    private destroyOnLanguageChange:() => void;
    private destroyOnAvailableLanguagesChange:() => void;

    static $inject = ['$rootScope', '$sce', 'TranslationService', 'UniqueIdService'];

    constructor($rootScope:IRootScope, $sce:ng.ISCEService, TranslationService:ITranslationService, UniqueIdService:IUniqueIdService) {

        this.rootScope          = $rootScope;
        this.sce                = $sce;
        this.translationService = TranslationService;
        this.uniqueIdService    = UniqueIdService;
    }

    $onInit() {
        if (!this.selectId) {
            this.selectId = this.uniqueIdService.getUniqueId('language-chooser');
        }

        const languageChangeCallback = () => {
            this.languages = this.translationService.getLanguages();

            for (const language of this.languages) {
                const toDisplayCountry = language.countryNative.length > 0 ? ' (' + language.countryNative + ')' : '',
                      toDisplay        = language.languageNative + toDisplayCountry;

                this.languagesDisplayed[language.locale] = this.sce.trustAsHtml(toDisplay);

                const currentLanguage = this.translationService.getCurrentLanguage();

                if (currentLanguage && language.locale === currentLanguage.locale) {
                    this.language       = language;
                    this.languageLocale = language.locale;

                    this.rootScope.language    = language.locale;
                    this.rootScope.rtlLanguage = language.rtl;
                    angular.element('body').css('direction', (language.rtl ? 'rtl' : 'ltr'));
                }
            }
        };

        this.destroyOnLanguageChange           = this.translationService.onLanguageChange(languageChangeCallback);
        this.destroyOnAvailableLanguagesChange = this.translationService.onAvailableLanguagesChange(languageChangeCallback);

        languageChangeCallback();
    }

    $onDestroy() {
        this.destroyOnLanguageChange();
        this.destroyOnAvailableLanguagesChange();
    }

    change() {
        for (const language of this.languages) {
            if (language.locale === this.languageLocale) {
                this.language = language;
            }
        }

        this.translationService.setCurrentLanguage(this.language);
        // updateGlobalLanguage() is now done in SessionController.onChangeLanguageRestart()
        // Update global language when user has confirm to switch language.
        // this.translationService.updateGlobalLanguage();
    }

}

app.component('languageChooser', {
    templateUrl : 'templates/components/languageChooser.html',
    controller  : LanguageChooserComponent,
    controllerAs: 'languageChooser',
    transclude  : true,
    bindings    : {
        selectId       : '@',
        additionalClass: '@'
    }
});